module.exports = __webpack_public_path__ + "img/Yostar_Logo@2x.2d4a607b.png";